import { Divider, Flex } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs, colors } from 'ui-components';
import { CreatorChannelMetrics } from '~/components/CreatorChannelMetrics';
import {
  FEATURE_FLAGS,
  PARTIALLY_SUPPORTED_PLATFORMS,
  SOCIAL_PLATFORMS,
} from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

import { PlatformCharts } from './PlatformCharts';

export type SupportedPlatforms =
  | SOCIAL_PLATFORMS.instagram
  | SOCIAL_PLATFORMS.tiktok
  | SOCIAL_PLATFORMS.youtube
  | PARTIALLY_SUPPORTED_PLATFORMS.snapchat;

export const platforms: SupportedPlatforms[] = [
  SOCIAL_PLATFORMS.instagram,
  SOCIAL_PLATFORMS.tiktok,
  SOCIAL_PLATFORMS.youtube,
];

export const CreatorDemographics: React.FC = () => {
  const foamTalentRecordChannelMetricsFlags = useFeature(
    FEATURE_FLAGS.foamTalentRecordChannelMetrics,
  );
  const foamSnapchatAnalyticsFlag = useFeature(
    FEATURE_FLAGS.foamSnapchatAnalytics,
  );

  const platformsToShow = useMemo(() => {
    if (foamSnapchatAnalyticsFlag.isEnabled) {
      return [...platforms, PARTIALLY_SUPPORTED_PLATFORMS.snapchat];
    }
    return platforms;
  }, [foamSnapchatAnalyticsFlag.isEnabled]);

  return (
    <section>
      <Tabs>
        <TabList>
          {platformsToShow.map((platform) => (
            <Tab key={platform} trackId={`tab-${platform}`}>
              {platform}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {platformsToShow.map((platform) => (
            <TabPanel key={platform}>
              <Flex direction="column" gap={6}>
                <PlatformCharts platform={platform} />
                {foamTalentRecordChannelMetricsFlags.isEnabled && (
                  <CreatorChannelMetrics platform={platform} />
                )}
              </Flex>
            </TabPanel>
          ))}
        </TabPanels>
        <Divider mt={6} mb={3} color={colors.primary[100]} />
      </Tabs>
    </section>
  );
};
